interface ProductColorSelectorProps {
  enabledColors: any[];
  selectedColor?: any;
  onColorChange: (colorId: string) => void;
  showColorError: boolean;
}

export const ProductColorSelector = ({ 
  enabledColors, 
  selectedColor, 
  onColorChange, 
  showColorError 
}: ProductColorSelectorProps) => {
  if (enabledColors.length === 0) return null;

  return (
    <div>
      <h3 className="font-semibold text-gray-900 mb-3">Pot Color</h3>
      <div className="flex flex-wrap gap-2">
        {enabledColors.map((color) => (
          <button
            key={color.id}
            onClick={() => onColorChange(color.id)}
            className={`flex items-center gap-2 px-4 py-2 border rounded-lg transition-colors ${
              selectedColor?.id === color.id
                ? 'border-primary bg-primary/5'
                : 'border-gray-300 hover:border-primary'
            }`}
          >
            <div
              className="w-4 h-4 rounded-full border border-gray-300"
              style={{ backgroundColor: color.hexColor }}
            />
             {color.name}
             {color.priceModifier && color.priceModifier > 0 && (
               <span className="ml-1 text-sm">+₹{color.priceModifier}</span>
             )}
          </button>
        ))}
      </div>
      {showColorError && (
        <p className="text-sm text-red-600 mt-2">
          Please select pot color
        </p>
      )}
    </div>
  );
};